// 使用方法回调的方式进行扩展
import { ViewModel, pageTo, syncAjax } from '@platform/api';
import * as constant from './const';
import * as log from './utils/log';
import { getModuleExports } from './model/free';
import axios from 'axios';
import path from './utils/path';
import { isArray, isFunction } from './utils/type';

// 这个东西呢  有三种做法  i.变量（get set）  ii.静态变量（static）  iii.全局变量
const DefaultExtendModuleName = constant.name;
const ModuleCacheName = constant.moduleCacheName;
const FreeExtendCacheName = constant.freeExtendCacheName;
const AreaConfigDefaultName = constant.areaConfigDefaultName;

const {
    getExtendUrl,
    getExtendTargetCatalogue,
    getPathPrefix,
} = path;

class FastExtend {
    constructor() {
        // 单据信息
        this.billinfo = null;

        // 销毁目标的缓存
        this.unstallTarget = {
            uniqueCruxPath: {},
            finalScriptSrc: {},
        };

        // 目标文件路径前缀
        this.pathPrefix = getPathPrefix();
        log.blue(`pathPrefix ${this.pathPrefix}`);

        // 是否使用了app路径构建目录
        this.loadAppPath = false;

        // 扩展成功回调
        this.loadSuccessCallback = null;

        // 记录加载完成的script数目  旧版本是1个  新版本是无限个 加载完成-1，为0时所有都加载完成
        this.loadScriptCount = 0;
        // 是否加载完成
        this.isReadyLoad = false;
        // 加载到的钩子
        this.moduleExports = {};
        // 是否开启了多层扩展开发
        this.isFreeExtendEnabled = (pageTo.getSearchParam('free_extend') || pageTo.getTopParam('free_extend')) === 'Y';
        // 是否开启了扩展开发
        this.isEnabled = this.isFreeExtendEnabled || (pageTo.getSearchParam('sec_develop') || pageTo.getTopParam('sec_develop')) === 'Y';
        // windows上挂的扩展方法对象字面量名称
        this.extendModuleAlias = [];
        // 用与方法解析的json
        this.preParseJson = null;
    }

    /**
     * 动态加载script
     * @param {*} modulePath 
     * @param {*} cruxPath 
     * @param {*} finalScriptSrc 
     * @param {*} alias 用于存储客开方法对象的别名 
     */
    loadScript = (modulePath, cruxPath, finalScriptSrc, alias) => {
        let script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = finalScriptSrc;

        // 计数
        this.loadScriptCount++;

        // 作为key,用于存储加载到的扩展方法
        let uniqueCruxPath = finalScriptSrc;
        if (script.readyState) {
            // ie 等旧版本兼容
            script.addEventListener('readstatechange', () => {
                if (script.readyState === 'loaded' || script.readyState === 'complete') {
                    this.onLoadSuccess.call(this, modulePath, uniqueCruxPath, finalScriptSrc, alias);
                }
            });
        } else {
            script.addEventListener('load', this.onLoadSuccess.bind(this, modulePath, uniqueCruxPath, finalScriptSrc, alias));
        }

        script.onerror = this.onError.bind(this, modulePath, cruxPath, finalScriptSrc, alias);

        try {
            document.body && document.body.appendChild(script);
            // script = null;
        } catch (e) {
            log.red(`${modulePath} script load error , not found src`);
        }

    }

    /**
     * 加载报错了
     * @param {*} modulePath 
     * @param {*} cruxPath 
     * @param {*} finalScriptSrc 
     * @param {*} alias 
     */
    onError = (modulePath, cruxPath, finalScriptSrc, alias = DefaultExtendModuleName) => {
        log.red(`${modulePath} script load error , not found src`);
        this.loadScriptCount--;

        this.removeScript(finalScriptSrc);
        // 用应用编码组成的路径再加载一次
        cruxPath = getExtendUrl(this.billinfo).appCodeUrl;
        finalScriptSrc = `${this.pathPrefix}${alias}/${cruxPath}/index.js`;
        if (cruxPath && !this.loadAppPath) {
            this.loadAppPath = true;
            modulePath = `${alias}/${cruxPath}/index`;
            this.loadScript(modulePath, cruxPath, finalScriptSrc, alias);
        }
    }

    /**
     * 加载成功了  
     * @param {*} modulePath 
     * @param {*} uniqueCruxPath 
     * @param {*} finalScriptSrc 
     * @param {*} alias  用于存储客开方法对象的别名 
     */
    onLoadSuccess = (modulePath, uniqueCruxPath, finalScriptSrc, alias = DefaultExtendModuleName) => {
        log.green(`加载成功`);

        // 记录一下用于销毁
        this.unstallTarget.uniqueCruxPath[uniqueCruxPath] = uniqueCruxPath;
        // 记录一下用于销毁
        this.unstallTarget.finalScriptSrc[finalScriptSrc] = finalScriptSrc;

        // 成功加载
        this.loadScriptCount--;
        // 获取挂载的方法
        let methods = getModuleExports(modulePath, alias);

        if (Object.keys(methods).length === 0) {
            log.orange('未加载到对应文件挂载的客开方法');
        }

        if (methods) {
            let extendCache = ViewModel.getData(ModuleCacheName) || {};
            if (!extendCache[uniqueCruxPath]) {
                extendCache[uniqueCruxPath] = {};
            }
            // 提供两个方法给  模板加载和数据加载使用
            if (methods.dataAlreadyLoaded && typeof methods.dataAlreadyLoaded === 'function') {
                extendCache[uniqueCruxPath].dataAlreadyLoaded = methods.dataAlreadyLoaded;
            }
            if (methods.beforeAjaxSend && typeof methods.beforeAjaxSend === 'function') {
                extendCache[uniqueCruxPath].beforeAjaxSend = methods.beforeAjaxSend;
            }

            if (methods.localExtendRouter && typeof methods.localExtendRouter === 'function') {
                extendCache[uniqueCruxPath].localExtendRouter = methods.localExtendRouter;
            }
            // 存储到viewModel缓存里
            ViewModel.setData(ModuleCacheName, extendCache);
            // 存储到当前对象上
            this.moduleExports[alias] = methods;
            // 记录一下名称
            this.extendModuleAlias.push(alias);
        }

        // 预处理多层扩展开发的数据  所有都加载完成后
        if (this.preParseJson && this.loadScriptCount === 0) {
            this.mergeExtendConfig();
        }

        // 所有层级加载完成
        this.isReadyLoad = this.loadScriptCount === 0;

        if (methods) {
            // 加载成功的回调
            this.loadSuccessCallback && this.loadSuccessCallback(methods);
        }
    }

    /**
     * 合并多层扩展开发的数据
     */
    mergeExtendConfig() {
        let { layers = [], component: jsonComponent = {}, page: jsonPage = {} } = this.preParseJson;
        layers.forEach(item => {
            let { alias = '' } = item;
            // 未找到对象
            if (!alias) {
                return;
            }
            // 模块导出的对象
            let exportObj = this.moduleExports[alias];
            if (!exportObj) {
                log.orange('未找到客开层级方法', alias);
            }

            let { page: modulePage, component: moduleComponent } = exportObj;

            // 页面级配置项
            for (const key in modulePage) {
                if (Object.hasOwnProperty.call(modulePage, key)) {
                    // 模块里导出的事件
                    const pageEvent = modulePage[key];
                    // json 里的页面级配置项
                    let pageConfig = jsonPage[key];
                    if (!pageConfig) {
                        pageConfig = jsonPage[key] = [];
                    }
                    // 如果找到配置项里有  就把方法放进去
                    let hasConfig = false;
                    pageConfig.forEach(item => {
                        let { layer } = item;
                        if (layer === alias) {
                            hasConfig = true;
                            item['method'] = pageEvent;
                        }
                    });
                    // 如果没有找到配置项，默认放在最后
                    !hasConfig && pageConfig.push({
                        layer: alias,
                        enable: true,
                        description: `module里没有指定执行顺序的事件 ${key}`,
                        method: pageEvent,
                    });
                }
            }

            // 区域级配置项
            for (const areaKey in moduleComponent) {
                if (Object.hasOwnProperty.call(moduleComponent, areaKey)) {
                    // 模块里导出的事对象  区域事件和属性
                    const areaExportObj = moduleComponent[areaKey];
                    if (!areaExportObj) {
                        log.orange('未找到相关扩展开发事件', alias, areaKey, moduleComponent);
                        continue;
                    }

                    // json 里的区域配置
                    let areaConfig = jsonComponent[areaKey];
                    if (!areaConfig) {
                        areaConfig = jsonComponent[areaKey] = {};
                    }

                    // 遍历模块区域层
                    for (const fieldKey in areaExportObj) {
                        if (Object.hasOwnProperty.call(areaExportObj, fieldKey)) {
                            // 模块里导出的事件
                            const areaFieldValue = areaExportObj[fieldKey];
                            // 配置项里的配置 事件层
                            let eventConfig = areaConfig[fieldKey];

                            // 区域层下如果是个方法  则和配置项中做匹配
                            if (isFunction(areaFieldValue)) {
                                // 如果配置项中  事件层是个数组  则认为事件层下没有字段层分组
                                if (isArray(eventConfig)) {
                                    // 如果找到了配置项
                                    let hasConfig = false;
                                    eventConfig.forEach(item => {
                                        let { layer } = item;
                                        if (layer === alias) {
                                            hasConfig = true;
                                            item['method'] = areaFieldValue;
                                        }
                                    });
                                    // 如果没有找到配置项，默认放在最后 最后执行
                                    !hasConfig && eventConfig.push({
                                        layer: alias,
                                        enable: true,
                                        description: `module里没有指定执行顺序的事件 ${fieldKey}`,
                                        method: areaFieldValue,
                                    });
                                } else {
                                    // 进入字段层
                                    eventConfig = areaConfig[fieldKey] || {};
                                    // 模块里导出  但是字段层里没有的配置
                                    let _defaultConfig = eventConfig[AreaConfigDefaultName] || [];

                                    // 导出事件和json配置的事件的合并 事件的字段层处理
                                    for (const fieldKey in eventConfig) {
                                        if (Object.hasOwnProperty.call(eventConfig, fieldKey) && fieldKey !== AreaConfigDefaultName) {
                                            const fieldConfig = eventConfig[fieldKey];
                                            // 如果找到了配置项
                                            let hasConfig = false;
                                            fieldConfig.forEach(item => {
                                                let { layer } = item;
                                                if (layer === alias) {
                                                    hasConfig = true;
                                                    item['method'] = areaFieldValue;
                                                }
                                            });
                                            // 如果没有找到配置项，默认放在最后 最后执行
                                            !hasConfig && fieldConfig.push({
                                                layer: alias,
                                                enable: true,
                                                description: `module里没有指定执行顺序的事件 ${fieldKey}`,
                                                method: areaFieldValue,
                                            });
                                        }
                                    }

                                    _defaultConfig.push({
                                        layer: alias,
                                        enable: true,
                                        description: `module导出的默认的事件 ${fieldKey}`,
                                        method: areaFieldValue,
                                    });

                                    eventConfig[AreaConfigDefaultName] = _defaultConfig;

                                    areaConfig[fieldKey] = eventConfig;
                                }
                            } else {
                                // 否则认为是属性
                                jsonComponent[areaKey]['field'] = jsonComponent[areaKey]['field'] || {};
                                jsonComponent[areaKey]['field'][fieldKey] = areaFieldValue;
                            }
                        }
                    }
                }
            }
        });

        // 回执
        this.preParseJson.component = jsonComponent;
        this.preParseJson.page = jsonPage;

        log.blue('合并对象后的json为', this.preParseJson);

        // var config = {
        //     "layers": [
        //         {
        //             "alias": "NCCExtend",
        //             "path": "NCCExtend/price\\price\\403000800\\403000800_card\\index.js"
        //         },
        //         {
        //             "alias": "LocalExtend",
        //             "path": "LocalExtend\\price\\price\\403000800\\403000800_card\\index.js"
        //         },
        //         {
        //             "alias": "NapoleonCakeExtend",
        //             "path": "NapoleonCakeExtend\\price\\price\\adjustprice\\403000800_card\\index.js"
        //         }
        //     ],
        //     "page": {
        //         "beforeAjaxSend": [],
        //         "beforeMetaUpdate": [],
        //         "beforeTriggerCreate": [],
        //         "pageRenderExtend": [
        //             {
        //                 "layer": "NCCExtend",
        //                 "enable": true,
        //                 "description": "测试 NCCExtend pageRenderExtend",
        //                 method: func
        //             },
        //             {
        //                 "layer": "LocalExtend",
        //                 "enable": true,
        //                 "description": "测试 LocalExtend pageRenderExtend",
        //                 method: func
        //             },
        //             {
        //                 "layer": "NapoleonCakeExtend",
        //                 "enable": true,
        //                 "description": "测试 NapoleonCakeExtend pageRenderExtend",
        //                 method: func
        //             }
        //         ],
        //     },
        //     "component": {
        //         "card_head": {
        //             field: {
        //                 showIndex: false,
        //                 showCheckbox: true,
        //                 moduleId: true,
        //             },
        //             "onBtnClick": [
        //                 {
        //                 "layer": "NCCExtend",
        //                 "enable": true,
        //                 "description": "测试 NCCExtend pageRenderExtend",
        //                 method: func
        //                   },
        //              ],
        //             "onBtnClick": {
        //                 __default_events: {
        //                      'LocalExtend': func
        //                 },
        //                 "btn_test_modal": [
        //                     {
        //                         "layer": "LocalExtend",
        //                         "enable": true,
        //                         "description": "测试 LocalExtend beforeBtnClick",
        //                     },
        //                     {
        //                         "layer": "NapoleonCakeExtend",
        //                         "enable": true,
        //                         "description": "测试 NapoleonCakeExtend beforeBtnClick",
        //                     },
        //                     {
        //                         "layer": "NCCExtend",
        //                         "enable": true,
        //                         "description": "测试 NCCExtend beforeBtnClick",
        //                     }
        //                 ]
        //             },
        //         }
        //     }
        // }
        ViewModel.setData(FreeExtendCacheName, this.preParseJson);
    }

    /**
     * 无限扩展的加载和处理
     * @param {Array} layers 扩展路径
     */
    loadInfiniteScript(data = {}) {
        // path = "NCCLocalExtend\\extend_price\\price\\price\\403000800\\403000800_list\\index.js"
        let { layers = [], component = {}, page = {} } = data;
        let layerPath = {};
        layers.forEach(item => {
            let { alias = '', path = '' } = item;
            // 未找到对象
            if (!alias || !path) {
                log.error(alias, '配置项出错，未找到alias', layerPath);
                log.error(path, '配置项出错，未找到path', layerPath);
                return;
            }

            // 清除下.js    
            path = path.replace('.js', '');

            // 分割路径
            let pathArr = path.split(/\\|\//gi);

            // 扩展的导出模块在window上的名称
            // let modulePath = `${alias}/${cruxPath}/index`;
            let modulePath = pathArr.join('/');

            // 扩展的唯一路径，用于关联扩展文件与扩展方法
            pathArr.shift(); // 去除客开的发布目录
            pathArr.pop(); // 去除 index 文件目录
            let cruxPath = pathArr.join('/');

            // 最终路径
            let finalScriptSrc = `${this.pathPrefix}${modulePath}.js`;

            // 用于加载
            layerPath[alias] = modulePath;

            this.loadScript(modulePath, cruxPath, finalScriptSrc, alias);
        });
        // 记录json数据关系
        this.preParseJson = {
            path: layerPath,
            component,
            page,
            layers,
        };
        ViewModel.setData(FreeExtendCacheName, this.preParseJson);
    }

    /**
     * 加载文件 mutativeLoadScrip
     * @param {*} callback 
     * @param {*} param1 
     * @returns 
     */
    install = (callback, { billinfo }) => {
        if (!this.isEnabled) {
            log.blue('未启用客开~');
            return;
        }
        if (!constant.enable) {
            log.blue('本页面禁止加载二开文件~');
            return;
        }
        log.green('加载开始');

        // 缓存数据
        this.billinfo = billinfo;
        this.loadSuccessCallback = callback;

        // 新版本
        let configJsonPath = getExtendTargetCatalogue(billinfo).appPathUrl;

        // 旧版本兼容
        // 扩展的关键路径 用于拼接最终加载路径
        let cruxPath = getExtendUrl(billinfo).appPathUrl;
        // 最终路径
        let finalScriptSrc = `${this.pathPrefix}${DefaultExtendModuleName}/${cruxPath}/index.js`;
        // 扩展的导出模块在window上的名称
        let modulePath = `${DefaultExtendModuleName}/${cruxPath}/index`;

        // TODO 必须要访问一次  才知道有没有多层开发 this.isFreeExtendEnabled
        if (configJsonPath) {
            // 异步
            axios.get(configJsonPath)
                .then(response => {
                    let data = response?.data;
                    if (data) {
                        try {
                            data = Object.prototype.toString.call(data) === '[object String]' ? JSON.parse(data) : data;
                            this.isFreeExtendEnabled = true;
                            this.loadInfiniteScript(data);
                        } catch (error) {
                            log.error(false, '加载json成功，但是执行解析报错', error, data, configJsonPath);
                        }
                    } else {
                        log.orange('未获取到配置文件数据，检查下路径或者配置文件内容');
                    }
                }).catch(error => {
                    log.warning('未加载到配置文件，启动旧模式兼容加载', error, error.response);
                    // 如果没有加载到json 就去尝试旧方法进行加载
                    if (cruxPath) {
                        this.loadScript(modulePath, cruxPath, finalScriptSrc);
                    }
                });
            // 同步
            // syncAjax({
            //     url: configJsonPath,
            //     success: (data, response) => {
            //         if (data) {
            //             try {
            //                 data = JSON.parse(data);
            //                 this.loadInfiniteScript(data);
            //             } catch (error) {
            //                 log.error(false, '非标准的json，解析报错', error);
            //             }
            //         } else {
            //             log.orange('未获取到配置文件数据，检查下路径或者配置文件内容');
            //         }
            //     },
            //     error: (status, message, headers) => {
            //         log.warning('未加载到配置文件，启动旧模式兼容加载', status, message, headers);
            //         // 如果没有加载到json 就去尝试旧方法进行加载
            //         if (cruxPath) {
            //             this.loadScript(modulePath, cruxPath, finalScriptSrc);
            //         }
            //     },
            // });
        } else {
            // 如果没有加载到json 就去尝试旧方法进行加载
            if (cruxPath) {
                this.loadScript(modulePath, cruxPath, finalScriptSrc);
            }
        }
    }

    /**
     * 移除文件
     * @param {*} src 
     */
    removeScript = src => {
        let $script = document.querySelector(`[src="${src}"]`);
        $script && document.body.removeChild($script);
    }

    /**
     * 卸载文件
     */
    unstall = () => {
        // 卸载二开文件
        // 销毁二开绑定在window上的事件

        // 销毁windows上的对象
        for (let uniqueCruxPath in this.unstallTarget.uniqueCruxPath) {
            if (uniqueCruxPath) {
                // let name = `NCCExtend${appcode}_${pagecode}`;
                if (window[DefaultExtendModuleName]) {window[DefaultExtendModuleName] = null;}
                let extendCache = ViewModel.getData(ModuleCacheName);
                if (extendCache) {
                    extendCache[uniqueCruxPath] = null;
                }
            }
        }

        // 销毁script 文件
        for (let finalScriptSrc in this.unstallTarget.finalScriptSrc) {
            if (finalScriptSrc) {
                this.removeScript(finalScriptSrc);
            }
        }

        // 销毁加载的json数据  freeExtendCacheJson
        ViewModel.setData(FreeExtendCacheName, '');
        this.preParseJson = null;
        this.moduleExports = {};
    }
}

FastExtend.defaultModuleName = DefaultExtendModuleName;
FastExtend.cacheModuleName = ModuleCacheName;

export default FastExtend;